import { PriceRangeFilter } from './components/priceRangeFilter/PriceRangeFilter';
import { CheckboxFilter } from './components/checkboxFilter/CheckboxFilter';
import { BrokerFilter } from './components/brokerFilter/BrokerFilter';
import { TransactionalFilter } from './components/transactionalFilter/TransactionalFilter';
import { FilterGroup } from './components/filterGroup/FilterGroup';
import { PropertyTypeFilter } from './components/propertyTypeFilter/PropertyTypeFilter';
import type { Filters as FiltersType } from '@/domain';
import { HouseRulesFilter } from '@/scenes/resultPage/components/filters/components/houseRulesFilter/HouseRulesFilter';

export type FilterProps = {
    filters: FiltersType;
    onFilterChanged: (filters: FiltersType) => void;
};
type FilterAndDataProps = FilterProps & {
    filterData: Record<string, unknown>;
};

const mapItems = (items: string[] = []): string[] => (Array.isArray(items) ? items : [items]);

export const Filters = ({ filterData, filters, onFilterChanged }: FilterAndDataProps) => (
    <section data-testid="filters" aria-label="Filtre">
        <FilterGroup title="Utleier">
            <BrokerFilter filters={filters} onFilterChanged={onFilterChanged} />
        </FilterGroup>
        {(!Object.hasOwn(filters, 'country') || filters.country === 'Norge') && (
            <FilterGroup title="Bestilling og betaling">
                <TransactionalFilter filters={filters} onFilterChanged={onFilterChanged} />
            </FilterGroup>
        )}
        <FilterGroup title={'Pris'} data-testid="FilterGroup-pris">
            <PriceRangeFilter filters={filters} onFilterChanged={onFilterChanged} />
        </FilterGroup>
        <FilterGroup title="Boligtype">
            <PropertyTypeFilter propertyTypes={mapItems(filters.property_types)} onFilterChanged={onFilterChanged} />
        </FilterGroup>
        <FilterGroup title="Husregler og tilgjengelighet">
            <HouseRulesFilter filters={filters} onFilterChanged={onFilterChanged} />
        </FilterGroup>
        <FilterGroup title="Fasiliteter">
            <CheckboxFilter
                onFilterChanged={onFilterChanged}
                filterData={filterData.facilities as string[]}
                filterValues={mapItems(filters.facilities)}
                filterType="facilities"
            />
        </FilterGroup>
        <FilterGroup title="I nærheten av">
            <CheckboxFilter
                onFilterChanged={onFilterChanged}
                filterData={filterData.pois_nearby as string[]}
                filterValues={mapItems(filters.pois_nearby)}
                filterType="pois_nearby"
            />
        </FilterGroup>
    </section>
);
